// apps/workflow/src/pages/layouts/ClientLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';

const ClientLayout = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
};

export default ClientLayout;